import { Component, OnInit } from '@angular/core';
import {
  AlertController,
  LoadingController,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment-timezone';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';
import { BehaviorSubject, filter, first } from 'rxjs';
import { Enterprise } from './models/models';
import { ToastService } from './services/toast.service';
import { LoaderUtils } from './utils/loader.utils';
import { ToastUtils } from './utils/toast.utils';
import { AlertUtils } from './utils/alert.utils';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  static enterprise: BehaviorSubject<Enterprise> = new BehaviorSubject(null);

  constructor(
    private platform: Platform,
    private dataService: DataService,
    private authService: AuthService,
    public toastService: ToastService,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private title: Title
  ) {}

  ngOnInit() {
    moment.locale('fr');
    moment.tz.setDefault('Europe/Paris');
    this.init();
    this.platform.ready().then(() => {
      LoaderUtils.init(this.loadingCtrl);
      ToastUtils.init(this.toastCtrl);
      AlertUtils.init(this.alertCtrl);
    });
  }

  async init() {
    await this.dataService.init();
    await this.authService.init();
    this.authService.authStatus
      .pipe(filter((status) => status && status.authDone && status.logged))
      .pipe(first())
      .subscribe(async (status) => {
        await LoaderUtils.createAndPresent();
        await this.dataService.loadData(status.enterprise?.id);
        LoaderUtils.dismiss();
      });
  }
}
